import { Button } from "@aircall/ds";
import { X } from "@aircall/react-icons";

import { EvaluationCreateFormHeaderProps } from "./EvaluationCreateFormHeader.decl";

export function EvaluationCreateFormHeader({
  title,
  onClose,
}: EvaluationCreateFormHeaderProps) {
  return (
    <div className="flex items-center justify-between border-b border-border px-4 py-3">
      <p className="text-xl font-bold">{title}</p>
      <Button
        variant="ghost"
        size="icon-sm"
        data-test="remove-scorecard-button"
        onClick={onClose}
      >
        <X className="size-4" />
      </Button>
    </div>
  );
}
